import {
  StyledSessionList
} from '../VsBattlePopup/VsBattlePopup.styled';
import { useAudio } from '../../providers/AudioContext';
import { AppContext } from '../../providers/AppContext';
import { useLevels, useTokenAuth, useKitchen, useShopItems } from '../../hooks';
import { playLevel } from '../../providers/BasejumpApiProvider';
import {
  KitchenHeader,
  KitchenBg,
  KitchenWrapper,
  KitchenContent,
  StyledKitchenTitle,
  KitchenTitleText,
  KitchenControls,
  KitchenMainSection,
  StyledKitchenOffers,
  StyledKitchenItem,
  KitchenItemBg,
  KitchenItemImageHolder,
  KitchenItemImage,
  KitchenItemCount,
  KitchenItemBuy,
  KitchenItemLock,
  StyledKitchenRow
} from './KitchenPopup.styled';
import {
  PopupHeaderStart,
  PopupHeaderEnd,
  PopupHeaderTitle,
  PopupHeader
} from '../PopupHeader/PopupHeader.styled';
import { IconButton, BroadsiderHudPopup } from '../';
import { theme } from '../../theme';
import { useContext, useState, useEffect } from 'react';

const ConsumablesTitle = () => {
  const background = theme.baseRed; 
  return (
    <PopupHeader>
      <PopupHeaderStart $background={background}/>
      <PopupHeaderTitle>
        Consumables
      </PopupHeaderTitle>
      <PopupHeaderEnd $background={background} />
    </PopupHeader>
  );
};

const KitchenTitle = () => {
  return (
    <StyledKitchenTitle>
      <KitchenTitleText><span className='shop-title-bold'>Eat or drink</span> to regain strength before your next battle</KitchenTitleText>
    </StyledKitchenTitle>
  )
};

const KitchenRow = ({ row }) => {
  return (
    <StyledKitchenRow>
      {row.map(i => <KitchenItem item={i}/>)}
    </StyledKitchenRow>
  );
};

const KitchenItem = ({ item: { item: asset, type, count }}) => {
  const { setSelectedAsset, setSelectedShopAsset } = useContext(AppContext);
  const [hovered, setHovered] = useState(false);
  const hasCount = !!count;
  const isLocked = asset.isLocked();
  const canBuy = (type === 'shop' && !isLocked);
  const { playSFX } = useAudio();

  const onMouseEnter = () => {
    setHovered(!isLocked);
    if (!isLocked) {
      playSFX('hover');
    }
  };
  const onMouseLeave = () => {
    setHovered(false);
  };

  const onClick = () => {
    if (!isLocked) {
      playSFX('button');
    }
    if (hasCount) {
      setSelectedAsset(asset);
    } else if (canBuy && !isLocked) {
      setSelectedShopAsset(asset);
    }
  };

  return (
    <StyledKitchenItem $hovered={hovered} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onClick={onClick}>
      <KitchenItemImageHolder $hovered={hovered}>
        <KitchenItemBg src='/assets/item_bg.png' $hovered={hovered}/>
        <KitchenItemImage src={asset.getImgSource()} $locked={isLocked}/>
        {hasCount && <KitchenItemCount>{count}</KitchenItemCount>}
        {isLocked && <KitchenItemLock src='/assets/kitchen_lock.svg'/>}
        {canBuy && <KitchenItemBuy>Buy</KitchenItemBuy>}
      </KitchenItemImageHolder>
    </StyledKitchenItem>
  );
};

const KitchenOffers = () => {
  const { inventoryItems } = useContext(AppContext);
  const { items: shopItems } = useShopItems();
  const { rows } = useKitchen(shopItems, inventoryItems); 
  return (
    <StyledKitchenOffers>
      {rows.map(r => <KitchenRow row={r}/>)}
    </StyledKitchenOffers>
  )
};

const KitchenPopup = ({ onGameStarted }) => {
  const { levels } = useLevels();
  const { selectedBroadsider } = useContext(AppContext);
  const { basejumpToken } = useTokenAuth();
  const { playSFX } = useAudio();

  const onAppear = () => {
    const playCustomSfx = Math.random() <= 0.2;
    if (playCustomSfx) {
      const sfx = `kitchen${Math.floor(Math.random() * 4) + 1}`;
      playSFX(sfx);
    }
  };

  const onNextBattle = async () => {
    const sortedLevels = levels.filter(l => !l.locked).sort((a, b) => b.order - a.order);
    const level = sortedLevels[0];
    const session = await playLevel(level.id, selectedBroadsider.getAvatarId(), basejumpToken);
    onGameStarted(session);
  };

  useEffect(() => {
    onAppear();
  }, []);

  return (
    <BroadsiderHudPopup>
      <StyledSessionList>
        <KitchenWrapper>
          <KitchenContent>
            <KitchenHeader>
              <img src='/assets/power_white.svg'/>
              <KitchenTitle />
            </KitchenHeader>
            <ConsumablesTitle />
	    <KitchenMainSection>
              <KitchenBg src='/assets/kitchen_bg.svg'/>
              <KitchenOffers/>
	    </KitchenMainSection>
	    <KitchenControls>
              <IconButton onClick={onNextBattle}>
                Next Battle
              </IconButton>
	    </KitchenControls>
          </KitchenContent>
        </KitchenWrapper>
      </StyledSessionList>
    </BroadsiderHudPopup>
  );
};

export default KitchenPopup;
